"use client";

import style from "./style.module.scss";
import Image from "next/image";
import { IMAGE_PATHS, GENERAL } from "@/constants";

const Message = ({ message, position }: { message: string, position: 'left' | 'right' }) => {
  return (
    <div className={`${style.messageContainer} ${position === 'left' ? style.left : style.right}`}>
      <div className={style.messageContent}>
        <Image className={style.messageTriangle} src={IMAGE_PATHS.ICONS.TRIANGLE} alt="message" width={GENERAL.IMAGE_SIZES.SMALL} height={GENERAL.IMAGE_SIZES.MEDIUM} />
        <p className={style.messageText}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default Message;


